export default __webpack_public_path__ + "static/media/miller_lite.8dbbcbec.png";